const AUTH_STORAGE_KEYS = ['access_token', 'type', 'full_name', 'role']

type AuthTokenPayload = {
  data?: {
    id?: string
    role?: string
    fullName?: string
    unit?: string
  }
  exp?: number
}

export function clearAuthStorage() {
  if (typeof window === 'undefined') return

  AUTH_STORAGE_KEYS.forEach((key) => window.localStorage.removeItem(key))
}

export function getAuthTokenPayload(): AuthTokenPayload | null {
  if (typeof window === 'undefined') return null

  const token = window.localStorage.getItem('access_token')

  if (!token) {
    clearAuthStorage()
    return null
  }

  try {
    const payload = JSON.parse(window.atob(token.split('.')[1]))

    if (payload?.exp && payload.exp * 1000 <= Date.now()) {
      clearAuthStorage()
      return null
    }

    return payload
  } catch (error) {
    clearAuthStorage()
    return null
  }
}
